<template>
  <div class="home-page" @scroll.passive="onScroll">
    <template v-if="!isRenderReady">
      <Skeleton />
    </template>
    <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
      <div class="header" ref="header">
        <div style="height: 20px"></div>
        <div :style="navStyleObj" class="fixed-nav-bar"></div>
        <div class="header-search-bar" :style="searchStyleObj">
          <van-search
            background="transparent"
            :placeholder="defaultSearchPlaceholder || '商品名称/拼音首拼/症状/疾病/厂家'"
            readonly
            shape="circle"
            @click="routerPage('/search-main')"
            class="search-input"
            :content-background="searchContentBackground"
          />

          <CartIcon
            style="margin-left: 8px"
            @onClick="routerPage('/request-cart')"
            :cartCountTrolley="cartCountTrolley"
          />
        </div>

        <div class="shadow-search" v-if="searchStyleObj.position" />

        <div style="overflow: hidden; height: 28px; margin-top: 4px">
          <div class="recommend-word-list" v-if="recommendWordList && recommendWordList.length">
            <span
              class="recommend-word"
              @click="onRecommendWordClick(item.title)"
              v-for="item in recommendWordList"
              :key="item.rcId"
            >
              {{ item.title }}
            </span>
          </div>
        </div>

        <div class="channel-list">
          <div @click="onLinkOpen(item.rcId)" class="channel-item" v-for="item in channelList" :key="item.rcId">
            <van-image :src="item.img + addOssParams(88, 88)" height="44" width="44" round />
            <p class="channel-text">{{ item.title }}</p>
          </div>
        </div>
      </div>
      <div class="brand-publicity">
        <span class="icon-box" v-for="(item, index) in tipList" :key="index">
          <van-image :src="item.img + addOssParams(32, 32)" height="16" width="16" style="margin-right: 4px" round />
          {{ item.title }}
        </span>
      </div>
      <div class="banner" v-if="bannerList && bannerList.length">
        <van-swipe class="custom-swipe" lazy-render autoplay="3000" :show-indicators="true" indicator-color="#ffffff">
          <van-swipe-item @click="onHrefOpen(item.href)" v-for="item in bannerList" :key="item.rcId">
            <van-image height="86" :src="item.img" />
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="bottom-list" v-if="tabList && tabList.length">
        <van-tabs
          v-model="activeTab"
          :line-width="20"
          background="transparent"
          @change="onTabChange"
          :sticky="true"
          :align="tabList.length <= 3 ? 'left' : 'around'"
          offset-top="44px"
          :ellipsis="tabList.length <= 3"
        >
          <van-tab v-for="(tab, index) in tabList" :key="tab.rcId" :title="tab.title">
            <van-list
              v-model="tab.loading"
              :finished="tab.finished"
              :finished-text="tab.dataList.length ? '没有更多了' : ''"
              error-text="请求失败，点击重新加载"
              :immediate-check="false"
              @load="onLoadMore(index)"
            >
              <div v-if="tab.dataList && tab.dataList.length" class="item-list">
                <item-detail
                  v-for="(item, index2) in tab.dataList"
                  :key="item.itemCode"
                  :item="item"
                  width="calc(50% - 4px)"
                  :isAdvertising="index2 === 0"
                  @onCartChange="getCartCountTrolley"
                />
              </div>

              <van-empty
                class="empty-margin"
                v-else-if="!tab.dataList.length && !tab.loading"
                description="暂无商品"
                image="//static.91jkys.com/attachment/20211021101256064_c7a906b021bc4f839e3e9fd8c02c9236.png"
              ></van-empty>
            </van-list>
          </van-tab>
        </van-tabs>
      </div>
      <div class="back-to-top" v-if="showReturnTop" @click="onReturnTopClick">
        <van-icon size="24" style="font-weight: bold; color: #595959" name="back-top" />
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { ResourceCodeEnum } from '@/constant';

import IconFont from '@/components/iconFont.vue';
import Skeleton from './components/skeleton.vue';

import { Swipe, SwipeItem } from '@zyf2e/capui-mobile';
import itemDetail from './components/itemDetail.vue';
import { CartIcon } from '@/components/search/index.js';

import VueScrollTo from 'vue-scrollto';

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  components: { IconFont, itemDetail, CartIcon, Skeleton },
  data() {
    return {
      isRenderReady: false,
      defaultBackGroundImg: '',
      defaultResourceID: ['ZYYDSC001', 'ZYYDSC002', 'ZYYDSC003', 'ZYYDSC004', 'ZYYDSC005', 'ZYYDSC006', 'ZYYDSC007'],
      refreshing: false,
      navStyleObj: {
        background: 'rgba(255, 255, 255, 0)',
        color: 'rgb(255, 255, 255)'
      },

      topBackground: '',

      // 基础信息
      defaultSearchPlaceholder: '',
      recommendWordList: [],
      defaultChannel: {
        rcId: 'all',
        img: 'https://static.91jkys.com/attachment/20211021114235362_d346c0077ddc4f89b85d6b3c1571b6a0.png',
        title: '全部分类'
      },
      tipList: [],
      bannerList: [],
      tabList: [],

      activeTab: 0,

      // 动态样式
      searchStyleObj: {
        background: 'transparent',
        position: '',
        'z-index': '1998',
        color: 'rgb(255, 255, 255)'
      },
      navStyleObj: {},
      searchContentBackground: '#ffffff',

      scrollTimer: null,
      isScroll: false,
      isTouched: false,
      isFixedSearch: false,

      showReturnTop: false,
      cartCountTrolley: null,
      pageSize: 10,
      resourceList: []
    };
  },
  created() {
    this.isRenderReady = false;
    if (localStorage.getItem('homeResourceList')) {
      const resourceList = JSON.parse(localStorage.getItem('homeResourceList'));
      this.renderResourceList(resourceList);
      // 有本地缓存，渲染同时 请求最新数据更新本地缓存
      this.getResourceList('cache');
    } else {
      this.getResourceList();
    }
    this.getCartCountTrolley();
  },
  mounted() {
    this.isTouched = document.querySelector('.home-page').scrollHeight <= window.innerHeight;
  },
  destroyed() {
    // eslint-disable-next-line no-unused-expressions
    this.timer && clearInterval(this.timer);
  },
  methods: {
    onScroll() {
      // 触碰了
      this.isTouched = true;
      const { scrollTop, offsetHeight } = this.$el;
      if (scrollTop > 20) {
        this.searchStyleObj = {
          ...this.searchStyleObj,
          position: 'fixed',
          top: '-1px',
          padding: '1px 12px 0',
          left: '0',
          width: '100%',
          'z-index': '1998'
        };
        this.searchStyleObj.background = 'rgba(255, 255, 255, 1)';
        this.searchStyleObj.color = 'rgb(0, 0, 0)';
        if (scrollTop >= 2 * offsetHeight) {
          this.showReturnTop = true;
        } else {
          this.showReturnTop = false;
        }
        this.searchContentBackground = 'rgb(245,245,245)';
      } else {
        const ratio = scrollTop / 20;
        const reversed = 1 - ratio;
        this.searchStyleObj = {
          background: 'transparent'
        };
        // this.searchStyleObj.background = `rgba(255, 255, 255, ${ratio})`;
        this.searchStyleObj.color = `rgb(${255 * reversed}, ${255 * reversed}, ${255 * reversed})`;
        this.searchContentBackground = 'rgb(255,255,255)';
      }
      this.daymicInviteIcon();
    },
    daymicInviteIcon() {
      this.isScroll = true;
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.isScroll = false;
      }, 1024);
    },

    /**
     * @method 交互事件
     *  */
    // 跳转
    routerPage(path) {
      this.$router.push(path);
    },
    // 下拉刷新
    onRefresh() {
      this.refreshing = true;
      this.activeTab = 0;
      this.getResourceList();
    },
    // tab切换
    async onTabChange(tabIndex) {
      const tab = this.tabList[tabIndex];
      if (tab.rcId === -1) return;
      if (tab.init || tab.loading || tab.finished) return;
      if (tab.pageNo > 1 || (tab.dataList || []).length) return;
      tab.loading = true;
      try {
        const { list = [], startIndex = 0 } = await this.getFallItemList(tab.rcId, tab.pageNo, tab.startIndex || 0);
        tab.dataList = list;
        tab.pageNo += 1;
        tab.startIndex = startIndex;
        if (list.length < this.pageSize) {
          tab.finished = true;
        }
        tab.init = true;
      } catch (err) {
        tab.finished = true;
        this.$toast('服务异常，请稍后再试');
      } finally {
        tab.loading = false;
      }
    },
    async onLoadMore(tabIndex) {
      const tab = this.tabList[tabIndex];
      tab.loading = true;
      try {
        const { list = [], startIndex = 0 } = await this.getFallItemList(tab.rcId, tab.pageNo, tab.startIndex || 0);
        tab.dataList.push(...list);
        tab.pageNo += 1;
        tab.startIndex = startIndex;
        if (list.length < this.pageSize) {
          tab.finished = true;
        }
      } catch (err) {
        tab.finished = true;
        this.$toast('服务异常，请稍后再试');
      } finally {
        tab.loading = false;
      }
    },
    onRecommendWordClick(val) {
      this.routerPage(`/search-main?keyword=${val}`);
    },
    onLinkOpen(val) {
      if (val === 'all') {
        this.routerPage('/all-categories');
      } else {
        this.routerPage(`/search-main?rcId=${val}`);
      }
    },
    onHrefOpen(href) {
      if (href) {
        window.location.href = href;
      }
    },

    /**
     * @method 获取数据
     */
    getResourceList(cache) {
      this.$fetch
        .getMallResourceStateList({ resourceCodeList: this.defaultResourceID })
        .then((res) => {
          const resourceList = res || [];
          this.resourceList = resourceList;
          localStorage.setItem('homeResourceList', JSON.stringify(resourceList));

          // 有本地缓存，请求到数据更新缓存 但不渲染页面
          if (!cache) {
            this.renderResourceList(resourceList);
          }
          this.refreshing = false;
        })
        .catch(() => {
          this.refreshing = false;
        });
    },
    getFallItemList(rcId, pageNo, startIndex) {
      return this.$fetch.getItemListByResourceId({
        rcId,
        pageSize: this.pageSize,
        pageNo,
        startIndex
      });
    },
    getCartCountTrolley() {
      this.$fetch.getCartCountTrolley().then((res) => {
        this.cartCountTrolley = res?.amount || null;
      });
    },

    renderResourceList(resourceList = []) {
      try {
        resourceList.forEach((resource) => {
          const { resourceContentList = [] } = resource;
          switch (resource.resourceCode) {
            case ResourceCodeEnum.DefaultSearchPlaceholder:
              this.defaultSearchPlaceholder = resourceContentList[0]?.title || '';
              break;
            case ResourceCodeEnum.RecommendWordList:
              this.recommendWordList = resourceContentList;
              break;
            case ResourceCodeEnum.ChannelList:
              const channelList = resourceContentList || [];

              channelList.push(this.defaultChannel);
              this.channelList = channelList;
              break;
            case ResourceCodeEnum.TipsList:
              this.tipList = resourceContentList || [];
              break;
            case ResourceCodeEnum.BannerList:
              // eslint-disable-next-line no-case-declarations
              const bannerList = (resourceContentList || []).map((item) => ({
                ...item,
                img: window.util.compressImg(item.img)
              }));
              this.bannerList = bannerList;
              // this.bannerList = bannerList.slice(0, 1);
              // eslint-disable-next-line no-case-declarations
              // const img = new Image();
              // img.onload = () => {
              //   setTimeout(() => {
              //     this.bannerList = bannerList;
              //   }, 0);
              // };
              // img.src = this.bannerList[0].img || '';
              break;
            case ResourceCodeEnum.TabList:
              const tabList = resourceContentList.map((content) => ({
                ...content,
                dataList: [],
                loading: false,
                init: false,
                finished: false,
                pageNo: 1,
                startIndex: 0
              }));

              this.tabList = tabList || [];
              if (this.tabList.length) {
                this.onLoadMore(0);
              }
              break;
            default:
              break;
          }
        });
      } catch (e) {
        this.$toast('数据加载失败');
      } finally {
        this.isRenderReady = true;
      }

      // if (this.channelList && !this.channelList.length) {
      //   this.channelList.push({
      //     rcId: 'all',
      //     img: 'https://static.91jkys.com/attachment/20211021114235362_d346c0077ddc4f89b85d6b3c1571b6a0.png',
      //     title: '全部分类'
      //   });
      // }
    },

    addOssParams(h, w) {
      return `?x-oss-process=image/resize,m_fill${w ? ',w_' + w : ''}${h ? ',h_' + h : ''}`;
    },
    onReturnTopClick() {
      const { header } = this.$refs;
      VueScrollTo.scrollTo(header, {
        container: this.$el,
        duration: 300,
        offset: 0
      });
    }
  }
};
</script>
<style lang="less" scoped>
.home-page {
  background: #f7f8fa;
  height: 100%;
  overflow-y: visible;
  overflow-x: hidden;
  .header {
    min-height: 210px;
    background: url('https://static.91jkys.com/upload/202107/16/131b1d1ecd694673bb47549ecf32a481.png?x-oss-process=image/resize,p_35');
    // background: url('./bg_mall_top.png');
    background-position-y: -20px;
    background-size: contain;
    background-repeat: repeat no-repeat;
    // padding: 0 12px;
    overflow: visible;
    &-search-bar {
      display: flex;
      align-items: center;
      padding: 0 12px;
      .search-input {
        width: 100%;
      }
    }
    .van-nav-bar {
      max-width: 90%;
      z-index: 1999;
    }
    /deep/ .van-nav-bar__left,
    /deep/ .van-nav-bar__right {
      padding: 0;
    }
    .fixed-nav-bar {
      width: 100%;
      height: 44px;
      position: fixed;
      z-index: -1;
      top: 0;
      left: 0;
    }
    .van-search {
      padding: 4px 0;
      z-index: 1998;
      .van-cell {
        padding: 6px 8px 6px 0;
      }
    }
    .shadow-search {
      width: 100%;
      height: 44px;
    }
    .recommend-word-list {
      // width: 100%;
      padding: 0 0 0 12px;
      // margin-top: 4px;
      height: 48px;
      overflow-y: hidden;
      overflow-x: scroll;
      display: flex;
      flex-wrap: nowrap;
      align-items: flex-start;
      padding-bottom: 20px;
      ::-webkit-scrollbar {
        display: none;
      }
      -webkit-overflow-scrolling: touch;
      .recommend-word {
        background: rgba(255, 255, 255, 0.15);
        border-radius: 12px;
        padding: 6px 8px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 1;
        display: inline-block;
        margin-right: 8px;
        flex: 0 0 auto;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .channel-list {
      // height: 184px;
      margin: 4px 12px 0;
      background: #fff;
      border-radius: 8px;
      display: flex;
      padding: 20px 13px 4px;
      flex-wrap: wrap;
      .channel-item {
        width: 48px;
        overflow: hidden;
        margin: 0 calc(25% - 60px) 16px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        &:nth-child(5n) {
          margin-right: 0;
        }
        .van-image {
          margin-bottom: 8px;
        }
        .channel-text {
          font-size: 12px;
          font-weight: 400;
          color: #595959;
          line-height: 1;
          width: 100%;
          word-break: keep-all;
        }
      }
    }
  }
  .brand-publicity {
    padding: 0 12px;
    margin: 8px 0 12px 0;
    display: flex;
    justify-content: space-between;
    .icon-box {
      display: flex;
      font-size: 12px;
      font-weight: 400;
      color: #8c8c8c;
      line-height: 16px;
      .van-icon {
        margin-right: 2px;
      }
    }
  }
  .banner {
    padding: 0 12px;
    .van-image {
      width: 100%;
    }
    .custom-swipe {
      ::v-deep.van-swipe__indicators {
        right: 12px;
        left: auto;
        transform: none;
      }
    }
  }
  .fixed-area {
    padding: 12px;
    width: 100%;
    .van-image:not(:last-child) {
      margin-right: 12px;
    }
  }

  .bottom-list {
    margin-top: 12px;
    // min-height: calc(100vh - 43px);
    /deep/ .van-sticky--fixed {
      background: #fff;
    }
    .item-list {
      margin-top: 12px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 12px;
      .item-detail-component {
        margin-bottom: 8px;
      }
    }
  }
  .back-to-top {
    position: fixed;
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px #bfbfbf;
    border-radius: 50%;
    z-index: 999;
    right: 12px;
    bottom: 44px;
    width: 44px;
    height: 44px;
    text-align: center;
    padding-top: 15px;
  }
}
</style>
